<script>
  import { fly } from "svelte/transition";
  import { debounce } from "underscore";

  import SearchHit from "./SearchHit.svelte";

  export let onClose = () => {};
  export let settings = {};

  let query = "";
  let fetching = false;
  const index = settings.index;

  function setQuery(newQuery) {
    if (query === newQuery) {
      return;
    }

    if (!newQuery) {
      query = newQuery;
      searchHits = [];
      return;
    }

    query = newQuery;
    fetching = true;
    searchHits = [];
    index
      .search(newQuery, { hitsPerPage: 100 })
      .then(({ hits }) => {
        searchHits = hits;
        fetching = false;
      })
      .catch((err) => {
        console.log(
          `Failed to load search results for query ${newQuery}. Error: ${err.toString()}`
        );
      });
  }

  let searchHits = [];
</script>

<div
  class="tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 tw-absolute tw-w-full tw-left-0 tw-top-12 tw-bg-white tw-z-20"
  in:fly={{ y: -10, duration: 200 }}
  out:fly={{ y: -10, duration: 200 }}
>
  <div class="tw-px-4 tw-mt-4 tw-w-full tw-mx-auto">
    <div class="tw-flex tw-flex-row tw-content-between tw-items-center">
      <div class="tw-flex tw-flex-row tw-flex-grow tw-items-center">
        <span
          on:click|stopPropagation={onClose}
          class="tw-m-1 tw-cursor-pointer tw-transition-transform tw-duration-500 tw-transform hover:tw-rotate-90 tw-text-xl"
          >&#10005;</span
        >
        <input
          value={query}
          class="tw-ml-4 tw-outline-none tw-border-0 tw-w-full focus:tw-border-0 tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-leading-tight"
          style="font-size: 16px;"
          type="text"
          name="query"
          placeholder={settings.queryPlaceholder}
          on:keyup={debounce(({ target: { value } }) => setQuery(value), 200)}
          autofocus
        />
      </div>
      <span
        on:click|stopPropagation={() => setQuery("")}
        class="tw-m-1 tw-cursor-pointer tw-underline tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-leading-tight"
        >{settings.clearButton}</span
      >
    </div>
    <hr class="tw-text-gray-200 tw-w-full" />
  </div>
  <div class="tw-px-4 tw-w-full">
    <div
      class="tw-px-2 tw-mt-8 tw-mb-4 max-h tw-overflow-y-auto tw-overflow-x-hidden"
    >
      <div class="flex flex-col tw-cursor-default" />
      {#if query === "" || searchHits.length === 0}
        {#if query !== "" && searchHits.length == 0 && !fetching}
          <div class="tw-my-2 tw-text-xl tw-font-serif">
            Your search for “{query}” didn’t return any results.
          </div>
        {/if}
        <div class="tw-text-2xl tw-font-serif tw-font-normal">
          {settings.popularQueriesTitle}
        </div>
        <div class="tw-flex tw-flex-wrap tw-my-4">
          {#each settings.popularQueries as searchSuggestion}
            <span
              on:click={() => setQuery(searchSuggestion)}
              class="tw-rounded-full tw-cursor-pointer tw-mr-2 tw-mb-2 tw-px-4 tw-py-2 tw-border tw-border-solid tw-border-gray-500"
              >{searchSuggestion}</span
            >
          {/each}
        </div>
        <div class="tw-text-2xl tw-font-serif tw-font-normal">
          {settings.popularProductsTitle}
        </div>
        <div class="tw-mt-4 tw-grid tw-grid-cols-2 tw-gap-4 tw-gap-y-6">
          {#each settings.popularProducts as featuredProduct}
            <SearchHit searchHit={featuredProduct} />
          {/each}
        </div>
      {:else}
        <div class="tw-text-xl">{searchHits.length} result(s)</div>
        <div class="tw-mt-4 tw-grid tw-grid-cols-2 tw-gap-4 tw-gap-y-6">
          {#each searchHits as searchHit}
            <SearchHit {searchHit} />
          {/each}
        </div>
      {/if}
    </div>
  </div>
</div>

<style>
  .max-h {
    max-height: calc(var(--vh, 1vh) * 100 - 250px);
  }
</style>
